import { ReactNode } from "react";
import { Layout } from "../layout";
import styles from "./landing-wrapper.module.scss";

interface Props {
  children: ReactNode;
}
export const LandingWrapper = ({ children }: Props) => (
  <Layout hideIA>
    <div id="loginScrollableContainer" className={styles.wrapper}>
      {children}
    </div>
  </Layout>
);
